import { render, staticRenderFns } from "./CwvPerformanceBreakdown.vue?vue&type=template&id=d561aae0&scoped=true&"
import script from "./CwvPerformanceBreakdown.vue?vue&type=script&lang=js&"
export * from "./CwvPerformanceBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d561aae0",
  null
  
)

export default component.exports